module.exports = __webpack_public_path__ + "img/freelancer-item-1.4913cbbc.png";